import { render, staticRenderFns } from "./goodsAllocationDetail.vue?vue&type=template&id=f7c92ea2&scoped=true&"
import script from "./goodsAllocationDetail.vue?vue&type=script&lang=js&"
export * from "./goodsAllocationDetail.vue?vue&type=script&lang=js&"
import style0 from "./goodsAllocationDetail.vue?vue&type=style&index=0&id=f7c92ea2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c92ea2",
  null
  
)

export default component.exports